<template>
    <td-dialog
        :title="$t('pgCommon.SET_USER')"
        append-to-body="true"
        :before-close="userDialogClose"
        :visible.sync="dialogUserVisible"
        width="810px"
        height="460px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-container>
            <el-header>
                <el-form :inline="true" :model="fromUser" ref="fromUser" class="demo-form-inline" :rules="rules">
                    <el-row :gutter="20">
                        <el-col>
                            <td-permission :permissions="permissionsView">
                                <div slot="havePermission">
                                    <el-form-item :label="$t('pgCommon.USERNAME')">
                                        <td-input placeholder="pgCommon.PLEASE_INPUT" v-model="fromUser.sName" :maxlength="20"></td-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('pgCommon.ROLENAME')">
                                        <td-input placeholder="pgCommon.PLEASE_INPUT" v-model="fromUser.roleName" :maxlength="20"></td-input>
                                    </el-form-item>
                                </div>
                            </td-permission>
                            <el-form-item>
                                <td-button type="primary" :permissions="permissionsView" :loading="loading" @click.native="queryPageList">{{ $t('pgCommon.QUERY') }}</td-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-header>
            <el-main>
                <!-- 加载表格 -->
                <td-table
                    :hasPageMemory="true"
                    height="400px"
                    :columns="columns"
                    :permissions="permissionsView"
                    :dataSource="tableData"
                    :pageSize="pageSize"
                    :currentPage="currentPage"
                    :total="total"
                    ref="fromUserList"
                    :hasMutiSelect="true"
                    :hasLoading="loading"
                    @handleSizeChange="handleSizeChange"
                    @currentChange="currentChange"
                    @selection-change="select"
                    rowKey="userId"
                ></td-table>
            </el-main>
        </el-container>
        <span slot="footer" style="text-align:left">
            <td-button type="primary" @click="save">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="userDialogClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from './../assets/api.js';
export default {
    props: ['dialogUserVisible', 'templateKey', 'userParam', 'userNames', 'userIds', 'currPage'],
    // 定义变量
    // 定义数据
    data() {
        return {
            fromUser: {
                sName: '',
                roleName: ''
            },
            editItem: '',
            sysFlg: '',
            permissionsAdd: ['userInfo:add'],
            permissionsEdit: ['userInfo:edit'],
            permissionsView: ['userInfo:view'],
            permissionsDel: ['userInfo:del'],
            permissionsImport: ['userInfo:import'],
            permissionsExport: ['userInfo:export'],
            roles: ['admin'],
            sysList: [],
            sysAndFlgList: [],
            orgList: [],
            orgTreeUrl: '',
            dialogUploadExcelVisible: false,
            dialogUserDetailVisible: false,
            tableData: [],
            selectRows: [],
            lastSelect: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                sName: [
                    {
                        pattern: this.$regex.USERCAPTION_RULE,
                        message: this.$t('error.ERROR_USER_CAPTION_ILLEGAL')
                    }
                ],
                roleName: [
                    {
                        pattern: this.$regex.ROLECAPTION_RULE,
                        message: this.$t('error.ERROR_ROLE_CAPTION_ILLEGAL')
                    }
                ]
            },
            columns: [
                {
                    prop: 'userName',
                    label: this.$t('pgCommon.USERNAME')
                },
                {
                    prop: 'roleName',
                    label: this.$t('pgCommon.USERROLE')
                }
            ]
        };
    },
    mounted() {
        this.btnQuery();
    },
    // 方法的实现
    methods: {
        // 根据user的id显示对应的类型名称
        formatterType(row) {
            switch (row.iType) {
                case 0:
                    return this.$t('pgCommon.RABBITMQ');
                // break
                default:
                    return this.$t('pgCommon.UNKNOW_TYPE');
            }
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.btnQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.btnQuery();
        },
        // 查询数据
        queryPageList() {
            this.currentPage = 1;
            this.btnQuery();
        },
        queryPageBySys() {
            this.currentPage = 1;
            if (this.sysFlg !== 'nextPageValue' && this.sysFlg !== 'lastPageValue') {
                this.btnQuery();
            }
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                userName: this.fromUser.sName,
                resName: this.fromUser.resName,
                roleName: this.fromUser.roleName,
                authName: this.fromUser.authName,
                sSysFlg: sessionStorage.getItem('systemId'),
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            Api.listUserInfos(param, response => {
                if (this.$common.requestCode.SUCCESS_INFO_CODE != response.data.statusCode) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getAllUsers', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
                this.feedBack();
            });
        },
        select(selection) {
            let userArr = [];
            let nameArr = [];
            for (let item in this.tableData) {
                userArr.push(this.tableData[item].userId);
                nameArr.push(this.tableData[item].userName);
            }
            for (let item in selection) {
                if (userArr.indexOf(selection[item].userId) > -1) {
                    nameArr.splice(userArr.indexOf(selection[item].userId), 1);
                    userArr.splice(userArr.indexOf(selection[item].userId), 1);
                }
            }
            for (let item in this.userIds) {
                for (let userItem in userArr) {
                    if (userArr[userItem] == this.userIds[item] && nameArr[userItem] == this.userNames[item]) {
                        this.userIds.splice(item, 1);
                        this.userNames.splice(item, 1);
                    }
                }
            }
            for (let item in selection) {
                if (this.userIds.indexOf(selection[item].userId) == -1) {
                    this.userIds.push(selection[item].userId);
                    this.userNames.push(selection[item].userName);
                }
            }
        },
        save: function() {
            let userIdStr = '';
            let userNameStr = '';
            for (let i = 0; i < this.userIds.length; i++) {
                if (userIdStr == '' && userNameStr == '' && typeof this.userIds[i] != 'undefined' && typeof this.userNames[i] != 'undefined') {
                    userIdStr += this.userIds[i];
                    userNameStr += this.userNames[i];
                } else if (typeof this.userIds[i] != 'undefined' && typeof this.userNames[i] != 'undefined') {
                    userIdStr += ',' + this.userIds[i];
                    userNameStr += ',' + this.userNames[i];
                }
            }
            if (!this.userIds.length || this.userIds.length == 0) {
                userIdStr = 'null';
            }
            let param = {
                processDefKey: this.templateKey,
                taskDefKey: this.userParam.taskKey,
                userIds: userIdStr,
                userNames: userNameStr,
                flag: this.userParam.tasksFlag,
                proDefId: this.templateKey + ':TEMP'

            };
            // Api.saveNodeUser(JSON.stringify(param), response => {
            //     if (this.$t(this.$common.requestCode.SUCCESS_INFO_CODE) != response.data.statusCode) {
            //         this.loading = false;
            //         this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
            //         this.$log.error('role/getRoleAuthList', response.data.statusMessage);
            //         return;
            //     }
            //     this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS'), type: 'success' });
            //     this.userDialogClose();
            // });
            this.$emit('submit', param);
        },
        // 回显
        feedBack() {
            this.loading = true;
            for (let i in this.currPage) {
                for (let j in this.tableData) {
                    if (this.tableData[j].userId == this.currPage[i]) {
                        this.$refs.fromUserList.toggleRowSelection(this.tableData[j], true);
                    }
                }
            }
            this.loading = false;
        },
        // // 查询回显数据
        // queryFeedBack() {
        //     this.loading = true;
        //     let param = {
        //         sId: this.templateKey + this.userParam.taskKey,
        //         processDefKey: this.templateKey,
        //         taskDefKey: this.userParam.taskKey,
        //         proDefId: this.templateKey + ':TEMP',
        //     };
        //     Api.queryNodeUser(JSON.stringify(param), response => {
        //         if (response.status !== this.$common.login.RESPONSE_STATUS) {
        //             this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
        //             this.loading = false;
        //             this.$log.error('queryNodeUser', response);
        //             return;
        //         }
        //         if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
        //             this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
        //             this.$log.error('queryNodeUser', response.data.statusMessage);
        //             return;
        //         }
        //         if (response.data.content.length > 0) {
        //             let userStr = response.data.content[0].userIds;
        //             let userNameStr = response.data.content[0].userNames;
        //             this.currPage = userStr.split(',');
        //             this.userIds = userStr.split(',');
        //             this.userNames = userNameStr.split(',');
        //         }
        //         this.btnQuery();
        //         this.loading = false;
        //     });
        // },
        userDialogClose: function() {
            this.$emit('userDialogClose');
            this.userDialogVisible = false;
        }
    }
};
</script>
